export default __webpack_public_path__ + "static/media/OpenSans-Regular-webfont.8fb00063.ttf";